import React, { useState, useEffect } from "react";
import { db } from "../service/firebase";
import Users from "../Users";

function Menu() {
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    db.collection("users").onSnapshot((snapshot) => {
      setAllUsers(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          users: doc.data(),
        }))
      );
    });
  }, [allUsers]);

  return (
    <div>
      <h3 className="text-center"> All Users </h3>
      <ul className=" list-unstyled mb-5 d-flex flex-column align-items-center ml-5 ">
        {allUsers
          .filter((data) => {
            if (data.users.visible === "true") {
              return data;
            }
            return null;
          })
          .map((data) => (
            <Users key={data.id} users={data.users} />
          ))}

        {/* {allUsers.map(({ id, users }) => (
          <Users key={id} users={users} />
        ))} */}
      </ul>
    </div>
  );
}
export default Menu;
